import Vue from 'vue'
import _random from 'lodash/random'
/**
 * 深拷贝
 * @param {*}} target 
 * @returns 
 */
export function deepCopy(target,ignores) {
    if (typeof target == 'object') {
        const result = Array.isArray(target) ? [] : {}
        for (const key in target) {
            // 如果存在需要忽略的属性，则忽略
            if(ignores){
                if(ignores.indexOf(key)>=0){
                    continue;
                }
            }

            if (typeof target[key] == 'object') {
                result[key] = deepCopy(target[key])
            } else {
                result[key] = target[key];
            }
        }

        return result
    }

    return target
}

export function swap(arr, i, j) {
    const temp = arr[i]
    arr[i] = arr[j]
    Vue.set(arr, i, arr[j])
    Vue.set(arr, j, temp)
}

export function $(selector) {
    return document.querySelector(selector)
}
/**
 * 判断是否为Mac系统
 * @returns 
 */
export function isMac(){
    return (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");
}

/** 获取相对于地图左上角的屏幕坐标 */
export function getOffsetX(e,map){
    var srcObj=map.getTargetElement();
    var rect = srcObj.getBoundingClientRect();
    var clientx = e.clientX;
    srcObj=null;
    return clientx - rect.left;
}
export function getOffsetY(e,map){
    var srcObj=map.getTargetElement();
    var rect = srcObj.getBoundingClientRect();
    var clienty = e.clientY;
    srcObj=null;
    return clienty - rect.top;
}


/**
 * 生成唯一id号
 */
export function generateID(){
    let fid=(new Date()).getTime();
    let r=_random(100000,199999);
    return fid+r;
}